import auth from "auth/store/reducers";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage";
import assignmentReducer from "./assignment/assignment.reducer";
import examOnlineReducer from "./onlineExam/onlineExam.reducer";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["onlineExam","assignment","auth","school", "capability", "schoolClass","course","category"],
  stateReconciler: hardSet,
  timeout: null,
};

const rootReducer = combineReducers({
  auth,
  onlineExam:examOnlineReducer,
  assignment:assignmentReducer
});

// const rootReducer = () => ({
//   test: { data: "hello dayamooz" },
// });

export default persistReducer(persistConfig, rootReducer);
